/** Размер аватара автора в вёрстке (`styles.scss`, `&__person-card-left`). */
export const AUTHOR_IMAGE_SIZE = 104;

/** Ширина, под которую подбираем копию картинки: бокс × 2 (retina). */
export const AUTHOR_IMAGE_TARGET_WIDTH = AUTHOR_IMAGE_SIZE * 2;
